import { Component, inject } from '@angular/core';
import { MercosurCommonNameService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MercosurCommonNameCreateDto,
  MercosurCommonNameDto,
  MercosurCommonNameExcelDownloadDto,
  MercosurCommonNameUpdateDto,
} from '../proxy/controlling/dtos/mercosur-common-name';
import { MERCOSURCOMMONNAME_CONFIG, MERCOSURCOMMONNAME_FIELDS } from './mercosur-common-name.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-mercosur-common-name',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MercosurCommonNameService, ConfirmationService],
  templateUrl: './mercosur-common-name.html',
  styleUrl: './mercosur-common-name.scss',
})
export class MercosurCommonName extends BaseCrudComponent<
  MercosurCommonNameDto,
  MercosurCommonNameCreateDto,
  MercosurCommonNameUpdateDto,
  MercosurCommonNameExcelDownloadDto
> {
  service = inject(MercosurCommonNameService);
  config = MERCOSURCOMMONNAME_CONFIG;
  fields = MERCOSURCOMMONNAME_FIELDS;

  protected prepareUpdateDto(data: any, selected: MercosurCommonNameDto): MercosurCommonNameUpdateDto {
    return {
      name: data.name,
      commonNameNumber: data.commonNameNumber,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MercosurCommonName';
  }
}
